import { Component } from '@angular/core';
import { NgForOf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

interface Reel {
  platform: string;
  url: string;
  handle: string;
  captionKey: string;
}

/**
 * Social proof / UGC strip. Reels link to the real posts/channels.
 * To embed an actual reel, replace a card with the platform's official embed.
 */
@Component({
  selector: 'app-landing-social',
  standalone: true,
  imports: [NgForOf, TranslateModule],
  templateUrl: './landing-social.component.html',
  styleUrls: ['./landing-social.component.scss'],
})
export class LandingSocialComponent {
  readonly igUrl = 'https://www.instagram.com/bipperz_app';
  readonly ttUrl = 'https://www.tiktok.com/@bipperz_app';
  readonly fbUrl = 'https://www.facebook.com/profile.php?id=61562285166415';
  readonly fbReelsUrl = 'https://www.facebook.com/profile.php?id=61562285166415&sk=reels_tab';

  readonly reels: Reel[] = [
    { platform: 'Instagram', url: 'https://www.instagram.com/p/DZo_Da1sYV6/', handle: '@bipperz_app', captionKey: 'maher' },
    { platform: 'Facebook', url: this.fbReelsUrl, handle: 'Bipperz', captionKey: 'fb' },
    { platform: 'TikTok', url: 'https://www.tiktok.com/@bipperz_app', handle: '@bipperz_app', captionKey: 'behind' },
    { platform: 'Instagram', url: 'https://www.instagram.com/bipperz_app', handle: '@bipperz_app', captionKey: 'app' },
  ];
}
